module.exports = __webpack_public_path__ + "static/media/sp-reservation-title-open@2x.eefac029.png";